import { useParams } from "react-router-dom";
import QuestionBuilder from "./QuestionBuilder";

const RegistryFormBuilder = () => {
  const { formId } = useParams();
  return <QuestionBuilder formId={formId || ""} type="platform" />;
};

export default RegistryFormBuilder;
